import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	teamLabel: {
		id: 'team',
		defaultMessage: 'Team',
		description: 'Team label text',
	},
	avatarLabel: {
		id: 'avatar',
		defaultMessage: 'Avatar',
		description: 'Avatar label text',
	},
});
